var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEveningJewelry = function SvgEveningJewelry(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LABELS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226,264a33.7,33.7,0,0,1-2.28-4.77A33.7,33.7,0,0,0,226,264Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.87,117.13c-1.63-4.14-1.92-15.88-7.74-13.64C310.14,111.91,307.89,130,318.87,117.13Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,100.44c-4.05,9.45,7.34,17.61,9.35,24.49C203.19,116.11,200.41,107.87,191,100.44Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.85,248a42.14,42.14,0,0,0,4.21,6.18A42.14,42.14,0,0,1,265.85,248Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,264c1.72,3.47,4.9,6,7.27,9.11C230.91,270,227.72,267.5,226,264Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.43,166.35l23.11-6.71C177.06,147.61,172,145.19,169.43,166.35Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.6,182.89l32-9.31C128.65,163.65,124,165.77,113.6,182.89Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.87,221.85a55.71,55.71,0,0,1-7.79-13.25A55.71,55.71,0,0,0,373.87,221.85Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.86,250.54a9.74,9.74,0,0,1-2.64.7A9.74,9.74,0,0,0,411.86,250.54Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.63,202.16c.62-.21,1.26-.41,1.9-.58C432.89,201.75,432.25,202,431.63,202.16Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.32,246l-3.11,2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,203.49c.86-.38,1.73-.74,2.61-1.07C430,202.75,429.14,203.11,428.28,203.49Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.43,140.05c-19.44-13.23-12.78-33.2-6.82-51.76C153,74.65,148.17,137.83,181.43,140.05Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36,164.5c20.54-2.76,16.81-21-3.42-18.62,2.65,5.39-4.29,18.23-10.92,10.74-7-20.25,34.45-12.8,11.63-33.32-9.86,34.55-55.65.13-25.8-4.17,2.78,2.25,5.58,7.14,4.47,11.48,9.58-.18,13.34-3.24,13.45-10.28-2.9-25.39-40.81-8.5-33.07,13.22C112.49,150.64,134.17,166,152.36,164.5Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.84,109.26c11.61-.4,8.78-24-3.76-21.82C275.55,89.58,277.37,112.64,290.84,109.26Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.85,129.6c-1.7-8.25,4.83-20.65-5.45-25.25C174.7,114.21,173.81,123.25,181.85,129.6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,161.39c-18-17.6-4.53,6.93-19.53,12.27C112.71,175,116.14,167.09,121.6,161.39Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.38,226.06c-8.63,14.57-30.95,16.44-41.85,3.84-1.91.1-22.77,15.17-24,11.16-1.29-3.58-2.63-3.1-5.54-1.29.69,1.55,3.6,4.73,1.11,6.06l-22.29,12.48c5.12,16-8.53,34.25-25.61,33.66,17.59,18.46,8,51.12-18,54.4,25.73,5.55,35.9,39.85,20.43,59.39,21.63-.45,39.44,15.65,43,36,15.93-22,55.63-16,70.23,6.43,4.76-31,39.86-55.11,71.46-44.63-7.94-24.76,7.85-53.46,33.86-59.56-40-39.51,22.15-76.59-84.06-48.13-12.76,4.88-21.66-8.75-9.83-16.8,2.29-1.87.77-3.43-.53-4.9-6-7.86-19.39-31-6.43-35.66C222.86,238.42,215.43,230,216.38,226.06Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,187.48c-9.78-16.71-20-20.67-10.81,0C79.13,188.6,84,187.57,89.38,187.48Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,165.47c13.39-3.85,2.59-24.68-8.11-20.56C77.36,149.48,87.18,171,97.5,165.47Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.22,251.24a7.31,7.31,0,0,1-1,0A7.31,7.31,0,0,0,409.22,251.24Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.87,141.84l32-9.31C268.94,123.74,263.88,124.07,254.87,141.84Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.42,118.48c-10.74,3.3-12.29-8.06-18.81-11.69C263.24,120.69,279.55,126.54,291.42,118.48Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.41,135.12c23.83-25.67-8.22-74.22-22.27-48.06C207.1,100.32,211.71,109.71,206.41,135.12Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.62,117.55c10.68,10.07-7.44,16.84-9.51,3.75-6.87,1.54-14.92,3.39-13.84,12.06,17.26,23.9,46.64-21.33,40.81-40.2C263.05,76,244.86,68,232.22,78.28c-11.57,8.89.11,30,13.87,17.65-5-4.26-3.27-16.41,4.71-14.53,14.53,7.81-.4,25.65-12.37,25.42-13.69-3.26-15.21-4.07-14.49,12C232.18,113.66,240.5,112.35,248.62,117.55Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.71,212.85c0,1,0,1.92,0,2.87h0C312.69,214.77,312.69,213.82,312.71,212.85Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.62,148.37c-13.74-17.29-17-11.11-24.75,7.2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,208.33a39.14,39.14,0,0,1-2-7.08A39.14,39.14,0,0,0,366,208.33Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.09,255.72q-1,.63-2,1.2Q475.09,256.35,476.09,255.72Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.27,227.87a6.55,6.55,0,0,1,.7.46A6.55,6.55,0,0,0,486.27,227.87Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.61,260c-.17.13-.35.25-.52.36C453.26,260.26,453.44,260.14,453.61,260Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.93,259a1.43,1.43,0,0,0-1.26-.81c3.51,3.76,6.79,4.17,10.6,1.91C464.24,261.21,460.94,263.41,457.93,259Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.64,250.39c.42-.45.8-.91,1.16-1.38-.36.47-.74.93-1.16,1.38Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.67,229.57a1.92,1.92,0,0,1-.35.73A1.92,1.92,0,0,0,487.67,229.57Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.14,241c.81-1.65,1.64-3.28,2.3-5C407.78,237.68,407,239.31,406.14,241Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.16,258.82c-5.34,4.9-7,12.59-10.05,19C498.19,271.41,499.82,263.72,505.16,258.82Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.67,229.57c.08-.44-.15-.82-.7-1.24C487.52,228.75,487.75,229.13,487.67,229.57Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.35,225.71c-.74-.79-1.89-.37-2.84-.35C480.46,225.34,481.61,224.92,482.35,225.71Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.86,261c-6.13-13,5.48-24.36,15.51-30.92-12.24,7-18.44,20.3-21.95,33.35.59-3.64,1.56-7.17,4.3-10.14C450.43,255.85,451.15,258.41,451.86,261Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.54,258.2c-.87.43-1.76.83-2.66,1.22C469.78,259,470.67,258.63,471.54,258.2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.32,225.7c.41-.09.83-.16,1.26-.22C478.15,225.54,477.73,225.61,477.32,225.7Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.59,208.82c-1.74,1-3.46,2.1-5.17,3.19C415.13,210.93,416.85,209.85,418.59,208.82Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.84,228.15c.1,1,.34,2.08,1.24,2.46C405.18,230.23,404.94,229.19,404.84,228.15Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.33,221.3c.06.85.13,1.7.2,2.55-.54-2.54.1-5.19,2.23-6.62-2.1,2.69-4.1,5.08-6.45,7.72C401.35,223.4,402.42,221.94,404.33,221.3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.73,244.61c.79-.46,1.63-.88,2.4-1.36C423.37,243.73,422.52,244.15,421.73,244.61Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.52,269.51c.24-1.37.41-2.75.6-4.13C444.93,266.76,444.76,268.14,444.52,269.51Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.12,229.59l1.26-.75Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.17,86.2c2.77,0,25.59.86,25.59,27.73a2.83,2.83,0,0,0,2.78,2.78,2.46,2.46,0,0,0,2.56-2.56c1-32.58,25.22-22.85,28.58-30.72a2.82,2.82,0,0,0-2.78-2.77c-30,2-22.7-41.36-31.13-27.73C411.68,87,372.06,75.92,384.17,86.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.38,252.54a26.37,26.37,0,0,1,2.39,5.77l22.29-12.48c2.5-1.32-.43-4.52-1.11-6.06-9,4.29-11,.61-2.69-4.81l-2.33-4.17c-1-4.21-25,12.72-26.7,12.65C115.91,245.71,119.47,248.74,121.38,252.54Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.26,230.84c.71,1.27-2.19,4.27-6.61,6.95,1.86,11,21-7,25.88-7.89A26.8,26.8,0,0,1,168,217.19c3.64,18.7,32.37,23.62,40.79,6,11.41-20.29-18.06-42-34.48-26.23,18.17-10.31,32.34,29.79,13.61,35.27-10.32,3.77-21.79-11.2-20.32-22.73,3.19,4.5-21.56,14.58-23.25,16.49-2.7,1.4.92,5.19,1.52,6.82C150.48,230.48,154.55,229.57,155.26,230.84Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,241.09c2.77,3,19.69-6.83,18.31-10.25C153.07,227.88,135.85,237.16,137,241.09Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.14,286.05c25.92,22.1,48.76-32.48,19.28-44.11,14,8.44,11.15,28.65-2.42,36.19-24.1,14-45.47-21.94-21.66-36.32C65.88,251.93,66.62,284.33,91.14,286.05Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.44,270.44c10.79,20.71,45.13,7.73,40.82-14.65-1.15,21-42.64,11-37-7.77,2.45-10.61,21-12.13,29.94-4.73C95.33,228,66.49,250.39,78.44,270.44Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,239.52c-23.69-7-31.55,20.88-7.72,27.34C121.33,274.14,127,244.79,104.44,239.52Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,246.47c1.23-1.88-.66-.36-1.45.19A1.16,1.16,0,0,0,257,246.47Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.09,242a39.38,39.38,0,0,0,2.76,6.05A39.38,39.38,0,0,1,263.09,242Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,282.22c.57-.68,1.16-1.33,1.76-2q-14.49,1.86-28.92,4.16C295.91,291.47,307.34,295.89,312.9,282.22Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.73,215.72c0,.07,0,.14,0,.21S312.73,215.79,312.73,215.72Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.29,359a37.63,37.63,0,0,0-4.71,7.33C37,363.81,39.27,361.74,40.29,359Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.53,345.59a42.28,42.28,0,0,1,5.26,1l-.61-.19c24.21-2.8,35.93-33.9,19.47-52,15.62,25.12-25.49,55.4-45.23,33.87C40.73,314.83,50.05,289,69.06,284.19c-31,5.69-33,52.33-3,60.95a38,38,0,0,0-7.8,1.61A46.46,46.46,0,0,1,75.53,345.59Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.19,312.47c-3.41,16.78-16,29.47-30.5,32.28,53.82,14.91,20.87,97.19-29.15,80.05,36.77,85.47-130.93,88.91-87.39.41a56,56,0,0,0-10.3,23,47.33,47.33,0,0,0-7.19-7.68c20.53,20.28,16.36,57-12.28,66.82-37.73,15.92-79.75-34.07-50.76-65.57a44,44,0,0,0-13.11-24.19c34.46,40.84-45.26,82.68-65.87,38.3-12.44-27.14,18.09-56,47-48.67a43.83,43.83,0,0,0-11.07-1.43c10.19-13.43,10-34-1.63-47.31,22.66,36.12-56.67,68.87-67.2,27.84,1,18.34,17.72,34.3,35.51,34.95-34.43,38.58,22.36,96.37,61.61,61.46,5,50.41,81,55.19,92.75,6.48,35,57.53,127,7.42,97.87-53.14,47.39,13.19,80.52-53.41,40.79-83.14,38.69-6.74,43.43-81.1-.42-76.74C369.37,284.13,374.15,297.9,371.19,312.47Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.17,344c-24.57,4.39-47.56,41.76-30.56,60.75-14.78-22.93,9.83-62,36.29-61a30.57,30.57,0,0,1-15.52-12.06A43.12,43.12,0,0,0,319.17,344Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,209.23l-.06.68A5.05,5.05,0,0,0,167.62,209.23Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32,197c16.42-15.73,45.9,5.94,34.48,26.23-8.42,17.59-37.15,12.67-40.79-6,3.8,22.75,36.57,28.92,48.37,8.87-.51,5.46,8.06,18.61,3,7-7.9-14.11,3.29-39.08,20.76-39.37,19.56-4,21.08,23.54,38.64,22.3-4.7-28.44-45.81-34.59-58.73-9-4.37-27.55-46.17-28.26-51.77-1.3A13.93,13.93,0,0,1,174.32,197Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.65,209c0-.29.06-.57.1-.84C167.71,208.45,167.68,208.73,167.65,209Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.14,286.05a27.42,27.42,0,0,0-20.39-2.27C77.3,282.24,85.68,283.09,91.14,286.05Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.58,300.31c-.45,25.31-60.4,21.86-46.07-6.14-33.88,55.06,69.15,51.42,44.52-.78A12.82,12.82,0,0,1,100.58,300.31Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.51,294.17c-14.33,28,45.64,31.44,46.07,6.14C99.83,278.47,63.6,278.47,54.51,294.17Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,207.52a29.17,29.17,0,0,1,9.21-10.46A27.34,27.34,0,0,0,218,213.93,33.64,33.64,0,0,1,220.66,207.52Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,207.52c-16,24.68,16.16,45.6,29.66,18.71C264.93,200.07,236,179.14,220.66,207.52Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,399.2c19.79-11.43,25.43-34.14,9.63-46.47,31.67,34.49-63.26,45.79-54.36,8.6C13.6,390.65,53.87,418.91,84,399.2Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.16,361.54c-7.38,28.22,55.38,30.33,60.07,7.29C103.62,339.24,47.05,338.21,39.16,361.54Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,432.91c-5,34.81-88.18,18.57-59.46-16.75C15.81,484,164,499,133.79,422.7A17,17,0,0,1,135,432.91Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.68,407.19c-17.14-3.43-37.56,2.53-41.58,19.07C72.34,483.56,184.46,434.71,111.68,407.19Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.69,291.81c-15.88,29.18,16.37,52.54,39.56,23.66,10.57-12.56,13.13-29.13,6.54-38.92C336.94,279.65,313.17,273,306.69,291.81Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.13,228.56c4.77,5.15,5.79-24.54-15.49-9.35A56.59,56.59,0,0,1,305.13,228.56Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.84,217.82a47.81,47.81,0,0,0,5.74,19.31A47.81,47.81,0,0,1,312.84,217.82Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.06,254.18c2.28,3,5.73,5.35,7.85,8.6C275.79,259.53,272.34,257.2,270.06,254.18Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,463c-6.81,42.52-98,11.68-67.07-25.81C84,511.19,249.62,546,213.8,450.63A22.6,22.6,0,0,1,215.59,463Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.17,428.58c-46.45-10.26-55.34,46.35-8,54.49C225.48,493,226.63,434.23,183.17,428.58Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.41,398.72c.9,3.28,1.63,6.55,5.26,7.43A21.45,21.45,0,0,1,286.41,398.72Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,363.47c-9.65,15.09-11.35,31.6-.33,42.68-25.21-13.88-75.45,3.45-70,36C232,488,339.16,450.31,297.28,409.78,367.78,423.15,357.29,294.31,292,363.47Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.69,218.35c7.12,23.64,34.74,15,27.12-8.48C188.44,185.16,160.68,196.82,168.69,218.35Z",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.69,241.67c-14.17-3.74-27.87,1.5-39.91,6.13.39-8.6,5.84-18,4.21-27.56-8.24-9.16-30.14-2-41.77,1.79-4.15.78-15.46,15-13,5.48,1-9.29,10.09-32.12-2.19-34.74-17.66,1.19-35,6.45-48.79,18,6.81-24.2-2-44.77-19.51-61.33-21.49,4.39-31.48,39.88-25.15,60.5-13.66-9.75-28.32-16.68-45.39-17.81-15.69-1.43-3.11,29.19-6,37.41-11.82-8.58-25.26-15-40.43-15-3.48-13.28-14.8-21.84-26.65-20.86,32.64,4.93,1.81,65.11-20.76,39.37,6.94,9.21-8.25,2-6.28,11.78,1.42,10.79,4.28,20.94,11.69,29.34,1.3,1.47,2.82,3,.53,4.9-19.5,22.34,15.7,17.54,28.23,11.69,32.6-7.47,65.95-11.79,99.28-14.2,20.13,25.56-37.35,78.8-49.51,37,1,13.49,8.82,25.77,21.62,30.15l-.67.09c48.83,3.13,8,83.32-27,65.95C344.41,457.82,205,491,223,427.66c-38.8,87.52,125.39,80.35,88.53-2.86,50,17.14,82.95-65.16,29.15-80.05,28.71-3.85,42.83-50.51,19.2-68.59,48.58-2.82,97.09,5.13,144.26,16.14,11,.43,27.28,14.48,35.08,2.43,6.44-9.86-8.74-12.26-3-18C542.36,268.63,554.37,248.67,544.69,241.67ZM322.8,200c30.46,2.46,58.69,43.63,45.52,68.16-19.87-3.32-40.39-12-49.74-31h0a47.81,47.81,0,0,1-5.74-19.31h0C313.79,207.07,306.13,194.53,322.8,200Zm-16.09,41c4,7.7,14.47,26.26,6.39,31.71-26.68,1.31-50-16.56-53.29-43.3C253.63,207.69,303.06,228.8,306.71,241Zm-49.35,4.37a1.25,1.25,0,0,1-1.82,1.3C256.17,246.25,256.78,245.82,257.36,245.36ZM263.62,281c-21.87,3.23-39.34-11.27-43.61-32.33-.56-2.66-.38-3.9,3.58-4C243.44,241.11,271.38,262.24,263.62,281ZM379,228c-14.28-14.13-21.79-37.53-9.8-55.31,3.11-4.32,9.3-20.69,15.67-12.21C404.4,177.69,403.32,219.19,379,228Zm58.56,18.48c-6.1,9.56-41.85,28.45-48.26,18.75.52-17.51,4.91-35.65,17.47-48,8-7,40.25-26.59,46.73-17.18C451.38,216.61,448.34,232.92,437.55,246.46Zm9.76,27.48c-7-1.23-.8-16.24,2.41-20.66,4.7-22.75,30.93-31.84,51.43-30.94C505.62,252.28,479.73,276.08,447.31,273.94Zm93.44-21.78c-1.86,20.36-31.87,41.25-46,27.36,4.52-19.87,21.57-35.6,42.85-32.21C540.47,247.63,542,248.65,540.75,252.16Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.67,197.13c-3.88.82-8.26.21-11.35,3.55,6,35.55-39.82,66.39-34,41.93.75-3.6,8-10.54,1.25-11.87-4.33-2.57.34-15.36-6.74-5.12-5.11,7.64-17.71,41.28-6,42.6,16.14-3.58,33-8.19,43.72-21.76C445.75,234.8,458.36,207.83,450.67,197.13Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.52,217.39c17.15,7.58,31.29,49.5,1.27,26.08-6.28-3.4,1.69,7.2-12.32,4.79,10.43,12.48,26.63,16.72,41.84,19.9,8.55-2.58.24-21.59-.25-29.19C357.53,187.79,266.69,194.86,337.52,217.39Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,245.16c-.53-3.66,1.33-2.68,3-1.69,30,23.42,15.87-18.51-1.27-26.08C288.47,189.07,323.86,263.66,335.79,245.16Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,220.69c-16.47-.28-2.89,15.69,7.33,12.31,14.12,0,30.39,13,28.4,26.5-5,5.19-14.18-9.22-16.3-.75-1.71,2.18-6.48.75-9.22,1.63,6.63,7.86,34.07,18,40,9C314.65,242.21,293.73,220,266,220.69Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.48,187.17c.41-6.65-11.76-32.5-13.66-16,.94,4.79.13,9.81,1.82,14.49,3.9,6-2.92,34.26-9.26,21.19-3.15-7.3-1.06-22.07-13.84-16.37-1.43,12.07,7.22,37.7,19.48,37.08C393.66,216.16,401.07,203.36,398.48,187.17Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.15,222.35c-5.49-.45-26.81.17-14.18,6-2.88,9,4.51,12.33-4.33,22.06-23.3,20.76-21.77,3.42-30.78,10.6h0c-.71-2.58-1.43-5.14-2.14-7.71-3.25,4.44-9.36,19.39-2.41,20.66C479.71,276.1,505.63,252.26,501.15,222.35Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.06,254.18c3.1,5.41,10.29,8.1,15.34,4.58.56-4.48,2.86-2.71,5.07-1.63,3.48,1.27,7.78,5.2,11.23,2.37C306,232.73,238.55,216.26,270.06,254.18Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.9,192.69c3.44,32.49,17,12.6,12.74-7.05-.91-6.65-4.11-15.56.68-21.12-8.86-19.33-24.1,16.1-23.78,25.93C367.62,188.19,373.75,189.41,373.9,192.69Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,249c-7.36-3.62-34.26-10.39-24.56,5.11,12.8-1.5,23.88-.41,31.44,13,4.18,15.79-26.52-12-19.75,6.8,7.29,5.08,28.19,12.76,31.9,3.6C263.1,265.55,258.46,254.84,246.73,249Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.6,247.31c-14.42-2.63-41.23,8.54-10.82,9.61,9.32,3.17-11.29,18.78-17.62,17.17-40.59,2.14,11.57,24.18,27.17-9.58C537.44,259.92,545.54,248.21,537.6,247.31Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.16,274.09c6.32,1.62,26.94-14,17.62-17.18C507.85,247.29,483.32,277.5,509.16,274.09Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8,272.26c-.16-11.23,10.73-1.12,16.83-.38,3.49,2.1,6.12-1.79,4-4.8C242.45,245.62,207.62,250.92,232.8,272.26Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.33,221.3c.82,2.82-.89,8.14,2.26,9.44,8.78,2.85-7.37,14.21-1.08,19.63,24.7,1,34.72-28.62,33.81-49.69C426.57,202.72,411.21,210.37,404.33,221.3Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.72,253.28c.71,2.57,1.43,5.13,2.14,7.71,8.94-7.22,7.42,10.2,30.78-10.6C502.63,210.39,455.73,224.72,449.72,253.28Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,190.74c-12.87,30.71,241.43-55.85,263.31-67.4,11.83-7.42-7.2-7.37-8.26-20.61-4.81-9.45-13.63-16.73-24.56-16-5.71-10.51-12.48-10-21.56-5.63A11.23,11.23,0,0,1,264,73.37c-14.82-13-29-4.13-44.58,1.73-21,5-29.81-13.19-52.09-6.37C151,111.9,114.17,86.94,100.68,121.94c2.78,8.09-5.24,16.49-13.41,14.23-10.35,3-8.6,19.67-17.47,25C60.06,169.07,71,181.14,67.93,190.74Zm243.2-87.25c5.83-2.25,6.11,9.5,7.74,13.64C307.88,130,310.14,111.9,311.13,103.49ZM113.6,182.89c10.43-17.13,15.06-19.23,32-9.31Zm55.83-16.54c2.59-21.18,7.65-18.72,23.11-6.71Zm30.95-41.42c-2-6.89-13.4-15-9.35-24.49C200.41,107.87,203.19,116.11,200.38,124.93Zm86.7-37.49c12.54-2.19,15.37,21.42,3.77,21.82C277.37,112.64,275.55,89.58,287.08,87.44Zm-14.47,19.35c6.52,3.63,8.07,15,18.81,11.69C279.55,126.54,263.25,120.68,272.61,106.79Zm14.26,25.74-32,9.31C263.88,124.06,269,123.75,286.87,132.53Zm-62.36-29.29c14.39,11.36,45.18-7.71,26.3-21.85-8-1.86-9.71,10.27-4.72,14.54-13.76,12.37-25.44-8.77-13.87-17.65,43.88-23,42.27,53,7.28,61.39-19.66,3.83-17.13-18.56-.38-18.37.28,4.8,4.46,6.91,8.25,7.71,15.49-11.4-14.8-20.22-23.43-10.24C224.15,113.14,224.34,107.89,224.51,103.24Zm6.11,45.13-24.75,7.2C213.61,137.24,216.89,131.1,230.62,148.37ZM186.44,78.26c28.34,4.87,37.11,27.58,20,56.86C219.66,94.9,182.37,100.12,186.44,78.26Zm-10,26.09c10.28,4.59,3.75,17,5.45,25.25C173.81,123.25,174.7,114.21,176.4,104.35Zm-7.7-21.18c14.73,13.9-16.4,38.76,12.73,56.88C153.92,131.68,148.44,105.76,168.7,83.17Zm-40,24.42c15.84-.43,19.14,24.7-.38,23,1.79-7.64-6.2-16.09-12.46-9.39-7.72,22.34,32.06,22.21,33.79,2.08,22.81,20.54-18.6,13-11.63,33.32,6.63,7.49,13.57-5.35,10.92-10.74,6.89,1.45,19.1-1.38,16.91,9.66C140.77,192.14,74.79,115.51,128.7,107.59ZM111.3,153.4c15.86,6.52,5.67,20.35-9.23,20.26C112.11,170.11,109.25,161,111.3,153.4Zm-21.91-8.49c10.7-4.12,21.5,16.71,8.11,20.56C87.18,171,77.36,149.48,89.39,144.91Zm-12.18,26.3,12.17,16.27c-5.4.09-10.25,1.12-10.8,0C77.49,182.81,70.52,172.84,77.21,171.21Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.23,69.19c14.32-2.54,10.06-25-4.22-22C154.62,49.67,159,72.14,173.23,69.19Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.86,81.07c14.27-2.48,10.09-25-4.22-22C258.32,61.54,262.55,84,276.86,81.07Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.07,136.3c14.32-2.52,10.1-25-4.21-22.05C73.46,116.79,77.91,139.27,92.07,136.3Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.32,430.23c-21.06,7,8.81-15.84-22.1-11.06-7.52-.29,3.86-11.14-4.29-15-4.07-3.45-4.18-4.1.09-7.54,15.25-14.8-6.41-34.76-6.88-51.71-2-13.51,13.51-18.29,19.14-6.55,7.06,10.71-8.07,30.41,5.58,36.76,7.1-.11-4.6-8.45-.39-15.83,6.93-17.1-9.3-45.29-26.65-26.61-15.15,16.59,26.5,54.25,1,59-5.63,3-1.17-7.05-5-7.91-5.65.23-3.45,11-.35,13.23,7.28,5.31-7.44,11.57-1.12,19.07,1.42,9-23.41-4.14-17.74,8.8,1.66,6.67,1.62,6.82-5.17,5-11.23-1.39-1.89,55.11-4.8,66.56.8,7-6.38,43.15,6.6,37,5.32-1.09,5.32-1.09,4,4.4-3.07,12.12,33.74,2.94,42.34,5.67,9,0,8.95,0,7.35-9-.4-8.13,14.2,6.05,11.66-6.5-.63-31.45,1.25-62.88.14-94.3C457.62,431.54,457.72,429.49,454.32,430.23ZM438.63,529c-10-3.27-38.76,7.08-39.07-6.49l-.07.13v-88.4h43.58C439.54,451.06,449.91,524.12,438.63,529Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.7,545.86q0-44.26,0-88.53c1.47-8.59-8.32-.17-11.26-2.7-1.7-1.84,1-4.94,1.52-7.53,2.37-10.28-19.71,1.4-17.91-7.43,2.51-4.95,1.4-9.09-2.91-12.39-5.82-5,6.76-8.21,4.94-14.65.8-5.7-6.39-6.88-5.41-.58,0,4.75-2.51,2.89-5.87,3-3.39,2.94-3.94-.14-4.84-2.28-4.36-18.54,27.87-51.22,0-61.9-28.58-2.22-13.81,30.17-20.34,44.91-1.53,1.7,1.74,4.21,2.95,2.54,9.92-9.95-2.86-25.66,4.73-37.13,5.57-8.55,18.84-7.57,18.92,4.41,2.28,19-24,39.65-6,56.09,1.24,7.26-9.89,9.25-4.63,17.61,1.36,7.8-18.88-3.43-15.93,6-.89,3.46,3.25,7.76,1.21,10.25-3.07,2.57-12-6.29-11.83,1.61q.38,48.78.66,97.57c0,3,1.06,3.5,3.9,2.59,15.41-6.72-.42,9.09,8.78,10.43,12.47-3.58,57.87,10.16,47.63-11.54C544.78,560.8,545.56,557,544.7,545.86Zm-15-85.95c1.47,28.94-.12,58.43.5,87.55-2.45,11.22-28.37,2.19-38.22,5.26-11.25-.63-1-82.9-4.24-96.09C487.66,458.87,539.64,452.07,529.72,459.91Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.76,516.26c-2.23,44-3.93,36.31,37.75,36.15,10.44.31,2.81-78.76,4.21-92.5l-42,85.11Z",
    fill: "#ef6ba0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.08,481.69c-.89-14.93,1.07-31.21-.66-46.08-.05.64-43.35,86.9-42.92,87.59,1.65,12.59,29,2.61,39.13,5.84C449.21,524.73,440.27,493.3,443.08,481.69Z",
    fill: "#ef6ba0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.63,160.74c-2.56,0-25.6-.85-25.6-27.73a2.77,2.77,0,0,0-5.54,0c-1,32.15-25,23.2-28.37,30.5a2.82,2.82,0,0,0,2.77,2.77c29.86-2.17,22.83,40.93,30.93,27.95C535.94,160,576.4,171.08,563.63,160.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.76,516.26V545c1.58-3.19,42.12-85.44,43.58-88.39C466.36,454.27,492.93,455.73,487.76,516.26Z",
    fill: "#f4abe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.07,434.28H399.49v88.4C400.2,521.24,442.41,435.63,443.07,434.28Z",
    fill: "#f4abe0"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEveningJewelry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/evening_jewelry.9ec9de14.svg";
export { ForwardRef as ReactComponent };